import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface MockNotificationProps extends BaseTemplateProps {}

export const MockNotification: TemplateDefinition<MockNotificationProps> = {
  renderParams: (props: MockNotificationProps) => ({
    messageKey: 'notificationsDomain.templates.mockNotification',
    values: {
      givenName: props.givenName,
      surname: props.surname,
    },
  }),
}
